import Logo from '@images/Logo.svg';

export default function LogoLink({ large = false, white = false }: { large?: boolean; white?: boolean }) {
  return isSubdomain ? (
    <div className={'flex flex-row items-center'}>
      <img
        alt="Boostboddy Logo"
        src={Logo}
        className={`mr-1.5 md:mr-3 ${white ? 'grayscale' : ''} ${large ? 'size-12 md:size-16' : 'size-8 md:size-10'}`}
      />
      <span
        className={`font-primary font-bold tracking-tighter ${white ? 'text-white' : 'text-primary'} ${large ? 'text-3xl md:text-4xl' : 'text-xl md:text-2xl'}`}
      >
        boostbuddy
      </span>
    </div>
  ) : (
    <a href={route('home')} className="flex flex-row items-center hover:opacity-75">
      <img
        alt="Boostboddy Logo"
        src={Logo}
        className={`mr-1.5 md:mr-3 ${white ? 'grayscale' : ''} ${large ? 'size-12 md:size-16' : 'size-8 md:size-10'}`}
      />
      <span
        className={`font-primary font-bold tracking-tighter ${white ? 'text-white' : 'text-primary'} ${large ? 'text-3xl md:text-4xl' : 'text-xl md:text-2xl'}`}
      >
        boostbuddy
      </span>
    </a>
  );
}
